module.exports = __webpack_public_path__ + "img/Icon_SFY.f8373602.png";